import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import {useHistory } from "react-router-dom";
import { baseurl } from "../../../../baseurl";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTable.css";
import "./baseForms.css";
import ExportToExcel from "../../SExport/ExportToExcle";
import { Button, Collapse, Table, Label, Input } from "reactstrap";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";
import { check_Bussiness_Permission } from "../../../../Helper";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");
function due_Formators(cell, row, enumObject, index) {
  if (cell === null || cell === undefined || cell === "") {
    return "";
  }

  if (typeof cell === "string") {
    return cell;
  }

  if (typeof cell === "number") {
    return cell.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  return String(cell);
}

export default function DemandReport(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [Level, setLevel] = useState(1);
const history = useHistory()

  const [data, setData] = useState({
    criteriaString: "All",
    collapseCriteria: true,
  });

  const [table, setTable] = useState({
    OverViewDataTable: [],
    printData: [],
    printData2: [],
    listOfData: [],
    listOfData2: [],
    listOfColLables: [],
    exportData: [],
    totalSumAll: null,
    selectedFDate: null,
    selectedTDate: null,
    selectedBranch: null,
  });

  const [filters, setFilters] = useState({
    subInventoryId: "",
    date: "",
    productionPlan: "",
    subInventory: "",
    level: "",
  });

  useEffect(() => {
    let propsData = props.location.state;
    // console.log("propsData", propsData);
    if (propsData) {
      setFilters({
        subInventoryId: propsData?.rowData?.sub_inv_id || "",
        date: propsData?.rowData?.formatedDate || "",
        productionPlan: propsData?.rowData?.id || "",
        subInventory: propsData?.rowData?.sub_inv_desc || "",
      });
    }
    checkBussinessPermission();
  }, []);
  useEffect(() => {
    if (filters.date && filters.productionPlan && filters.subInventoryId) {
      getDemandReport(
        filters.date,
        filters.productionPlan,
        filters.subInventoryId
      );
    }
    // console.log("imrunningggggg");
  }, [filters]);

  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission[0]);
  };

  const listOfColKey = [
    { align: "left", value: "item_code" },
    { align: "left", value: "ITEM_DESC" },
    { align: "left", value: "qty" },
    { align: "left", value: "M_ITEM_CODE" },
    { align: "left", value: "M_ITEM_DESC" },
    { align: "right", value: "REQ_QTY" },
    { align: "right", value: "STOCK_QTY" },
    { align: "right", value: "TO_PRODUCE" },
  ];
  const listOfColLables = [
    { align: "left", value: "Production Code" },
    { align: "left", value: "Production Name" },
    { align: "left", value: "Qty" },
    { align: "left", value: "Recipe Item Code" },
    { align: "left", value: "Recipe Item Name" },
    { align: "right", value: "Quantities Required" },
    { align: "right", value: "Quantities Stock" },
    { align: "right", value: "Quantities To Produce" },
  ];
  const listOfColKey2 = [
    { align: "left", value: "M_ITEM_CODE" },
    { align: "left", value: "M_ITEM_DESC" },
    { align: "right", value: "REQ_QTY" },
    { align: "right", value: "STOCK_QTY" },
    { align: "right", value: "TO_PRODUCE" },
  ];
  const listOfColLables2 = [
    { align: "left", value: "Recipe Item Code" },
    { align: "left", value: "Recipe Item Name" },
    { align: "right", value: "Quantities Required" },
    { align: "right", value: "Quantities Stock" },
    { align: "right", value: "Quantities To Produce" },
  ];

  const [filteredData, setFilteredData] = useState([]);

  const getDemandReport = async (
    fromDate = filters.date,
    productionPlan = filters.productionPlan,
    subInventory = filters.subInventoryId
  ) => {
    setIsLoading(true);
    try {
      const fDate = fromDate
        ? moment(fromDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

      const response = await axios.post(
        `${baseurl}/repots/purchaseorderreport`,
        {
          Date: fDate || "",
          productionPlan: productionPlan || "",
          subInventory: subInventory || "",
          username,
          companyId,
        },
        {
          headers: { authorization: token },
        }
      );
      const callData = response.data.data;
      const callData2 = response.data.data2;
      processTableData(callData, callData2, fromDate, null, null);
    } catch (error) {
      console.error("Error fetching demand report:", error);
      setIsLoading(false);
    }
  };

  const processTableData = (
    callData,
    callData2,
    fromDate,
    toDate,
    branch_id
  ) => {
    let mainScreenData = [];
    let mainScreenData2 = [];
    let printData = [];
    let printData2 = [];

    // Header arrays for Level 1
    let newArr = [
      {
        item_code: "Production Report Summary",
        ITEM_DESC: "",
        qty: "",
        M_ITEM_CODE: "",
        M_ITEM_DESC: "",
        REQ_QTY: "",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        item_code: "",
        ITEM_DESC: "",
        qty: "",
        M_ITEM_CODE: "",
        M_ITEM_DESC: "",
        REQ_QTY: "",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        item_code: "Production Item",
        ITEM_DESC: "",
        qty: "",
        M_ITEM_CODE: "Recipe Items",
        M_ITEM_DESC: "",
        REQ_QTY: "Quantities",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        item_code: "Code",
        ITEM_DESC: "Name",
        qty: "Qty",
        M_ITEM_CODE: "Code",
        M_ITEM_DESC: "Name",
        REQ_QTY: "Required",
        STOCK_QTY: "Stock",
        TO_PRODUCE: "To Produce",
      },
    ];

    // Header arrays for Level 2
    let newArr2 = [
      {
        M_ITEM_CODE: "Production Report Summary",
        M_ITEM_DESC: "",
        REQ_QTY: "",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        M_ITEM_CODE: "",
        M_ITEM_DESC: "",
        REQ_QTY: "",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        M_ITEM_CODE: "Recipe Items",
        M_ITEM_DESC: "",
        REQ_QTY: "Quantities",
        STOCK_QTY: "",
        TO_PRODUCE: "",
      },
      {
        M_ITEM_CODE: "Code",
        M_ITEM_DESC: "Name",
        REQ_QTY: "Required",
        STOCK_QTY: "Stock",
        TO_PRODUCE: "To Produce",
      },
    ];

    // Process Level 1 data (callData)
    if (callData && Array.isArray(callData)) {
      callData.forEach((element, index) => {
        const rowData = {
          id: index + 1,
          item_code: element.item_code || "",
          ITEM_DESC: element.ITEM_DESC || "",
          qty: Number(element.qty) || 0,
          M_ITEM_CODE: element.M_ITEM_CODE || "",
          M_ITEM_DESC: element.M_ITEM_DESC || "",
          REQ_QTY: Number(element.REQ_QTY) || 0,
          STOCK_QTY: Number(element.STOCK_QTY) || 0,
          TO_PRODUCE: Number(element.TO_PRODUCE) || 0,
        };

        mainScreenData.push(rowData);

        printData.push({
          item_code: element.item_code,
          ITEM_DESC: element.ITEM_DESC,
          qty: due_Formators(element.qty),
          M_ITEM_CODE: element.M_ITEM_CODE,
          M_ITEM_DESC: element.M_ITEM_DESC,
          REQ_QTY: due_Formators(element.REQ_QTY),
          STOCK_QTY: due_Formators(element.STOCK_QTY),
          TO_PRODUCE: due_Formators(element.TO_PRODUCE),
        });

        newArr.push({
          item_code: element.item_code,
          ITEM_DESC: element.ITEM_DESC,
          qty: due_Formators(element.qty),
          M_ITEM_CODE: element.M_ITEM_CODE,
          M_ITEM_DESC: element.M_ITEM_DESC,
          REQ_QTY: due_Formators(element.REQ_QTY),
          STOCK_QTY: due_Formators(element.STOCK_QTY),
          TO_PRODUCE: due_Formators(element.TO_PRODUCE),
        });
      });
    }

    // Process Level 2 data (callData2)
    if (callData2 && Array.isArray(callData2)) {
      callData2.forEach((element, index) => {
        const rowData2 = {
          id: index + 1,
          M_ITEM_CODE: element.M_ITEM_CODE || "",
          M_ITEM_DESC: element.M_ITEM_DESC || "",
          REQ_QTY: Number(element.REQ_QTY) || 0,
          STOCK_QTY: Number(element.STOCK_QTY) || 0,
          TO_PRODUCE: Number(element.TO_PRODUCE) || 0,
        };

        mainScreenData2.push(rowData2);

        printData2.push({
          M_ITEM_CODE: element.M_ITEM_CODE,
          M_ITEM_DESC: element.M_ITEM_DESC,
          REQ_QTY: due_Formators(element.REQ_QTY),
          STOCK_QTY: due_Formators(element.STOCK_QTY),
          TO_PRODUCE: due_Formators(element.TO_PRODUCE),
        });

        newArr2.push({
          M_ITEM_CODE: element.M_ITEM_CODE,
          M_ITEM_DESC: element.M_ITEM_DESC,
          REQ_QTY: due_Formators(element.REQ_QTY),
          STOCK_QTY: due_Formators(element.STOCK_QTY),
          TO_PRODUCE: due_Formators(element.TO_PRODUCE),
        });
      });
    }

    // Calculate totals for Level 1
    const totalSumAll = mainScreenData.reduce(
      (acc, curr) => ({
        REQ_QTY: acc.REQ_QTY + (Number(curr.REQ_QTY) || 0),
        STOCK_QTY: acc.STOCK_QTY + (Number(curr.STOCK_QTY) || 0),
        TO_PRODUCE: acc.TO_PRODUCE + (Number(curr.TO_PRODUCE) || 0),
      }),
      {
        REQ_QTY: 0,
        STOCK_QTY: 0,
        TO_PRODUCE: 0,
      }
    );

    // Calculate totals for Level 2
    const totalSumAll2 = mainScreenData2.reduce(
      (acc, curr) => ({
        REQ_QTY: acc.REQ_QTY + (Number(curr.REQ_QTY) || 0),
        STOCK_QTY: acc.STOCK_QTY + (Number(curr.STOCK_QTY) || 0),
        TO_PRODUCE: acc.TO_PRODUCE + (Number(curr.TO_PRODUCE) || 0),
      }),
      {
        REQ_QTY: 0,
        STOCK_QTY: 0,
        TO_PRODUCE: 0,
      }
    );

    // Add blank rows and totals to Level 1
    newArr.push({
      item_code: "",
      ITEM_DESC: "",
      qty: "",
      M_ITEM_CODE: "",
      M_ITEM_DESC: "",
      REQ_QTY: "",
      STOCK_QTY: "",
      TO_PRODUCE: "",
    });

    newArr.push({
      item_code: "Total",
      ITEM_DESC: "",
      qty: "",
      M_ITEM_CODE: "",
      M_ITEM_DESC: "",
      REQ_QTY: totalSumAll.REQ_QTY,
      STOCK_QTY: totalSumAll.STOCK_QTY,
      TO_PRODUCE: totalSumAll.TO_PRODUCE,
    });

    printData.push({
      item_code: "Total",
      ITEM_DESC: "",
      qty: "",
      M_ITEM_CODE: "",
      M_ITEM_DESC: "",
      REQ_QTY: due_Formators(totalSumAll.REQ_QTY),
      STOCK_QTY: due_Formators(totalSumAll.STOCK_QTY),
      TO_PRODUCE: due_Formators(totalSumAll.TO_PRODUCE),
    });

    // Add blank rows and totals to Level 2
    newArr2.push({
      M_ITEM_CODE: "",
      M_ITEM_DESC: "",
      REQ_QTY: "",
      STOCK_QTY: "",
      TO_PRODUCE: "",
    });

    newArr2.push({
      M_ITEM_CODE: "Total",
      M_ITEM_DESC: "",
      REQ_QTY: totalSumAll2.REQ_QTY,
      STOCK_QTY: totalSumAll2.STOCK_QTY,
      TO_PRODUCE: totalSumAll2.TO_PRODUCE,
    });

    printData2.push({
      M_ITEM_CODE: "Total",
      M_ITEM_DESC: "",
      REQ_QTY: due_Formators(totalSumAll2.REQ_QTY),
      STOCK_QTY: due_Formators(totalSumAll2.STOCK_QTY),
      TO_PRODUCE: due_Formators(totalSumAll2.TO_PRODUCE),
    });

    setTable({
      OverViewDataTable: mainScreenData,
      OverViewDataTable2: mainScreenData2,
      printData,
      printData2,
      listOfData: newArr,
      listOfData2: newArr2,
      listOfColLables: listOfColLables,
      totalSumAll: totalSumAll,
      totalSumAll2: totalSumAll2,
      selectedFromDate: fromDate,
      selectedToDate: toDate,
      selectedBranch: branch_id?.label || "All",
    });

    setFilteredData(mainScreenData);
    setIsLoading(false);
  };

  const funPrintView = (data1, headers, headerKeyMap) => {
    const { selectedFromDate, selectedToDate, selectedBranch } = table;

    let dateCriteria = filters.date
      ? moment(filters.date).format("DD-MMM-YYYY")
      : "All";

    let criteria = [
      { label: "Date", value: dateCriteria },
      { label: "Production Plan", value: filters.productionPlan || "All" },
      { label: "Sub Inventory", value: filters.subInventory || "All" },
      { label: "Level", value: Level === 1 ? "Level 1" : "Level 2" },
    ];

    props.history.push({
      pathname: "/PrintReports",
      state: {
        data: data1,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/productionPlanOverview",
        dynamicInvMessage: "Production Report Summary",
        reportName: "Production_Report_Summary",
        criteria,
        criteriaString: data.criteriaString,
        groupedHeaders: true,
      },
    });
  };
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value:
          Level === 1
            ? table.OverViewDataTable?.length
            : table.OverViewDataTable2?.length,
      },
    ],
  };

  const onChangeRadio = (e) => {
    const newLevel = parseInt(e.target.value);
    setLevel(newLevel);

    if (newLevel == 1) {
      setFilteredData(table.OverViewDataTable);
    } else {
      setFilteredData(table.OverViewDataTable2);
    }
  };

  const getCurrentPrint = () => {
    if (Level === 1) {
      return {
        printData: table.printData,
        headers: listOfColLables,
        headerKeyMap: listOfColKey,
        listOfData: table.listOfData,
      };
    } else {
      return {
        printData: table.printData2,
        headers: listOfColLables2,
        headerKeyMap: listOfColKey2,
        listOfData: table.listOfData2,
      };
    }
  };

  const currentData = getCurrentPrint();

  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <div translate="no" className="mt-5">
            <div className="sticky-table-wrapper ">
              <div className="row align-items-center p-3">
                <div className="col-md-8">
                  <h3 className="m-0"> Production Order Report & Summary</h3>
                </div>

                <div className="col-md-4 d-flex justify-content-end">
                  <Button
                    color="secondary"
                    className="rounded-pill"
                    onClick={() => history.push("/productionPlanOverview")}
                  >
                    <i className="fa fa-arrow-left pr-2"></i> Back to Overview
                  </Button>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-3">
                  <label htmlFor="">Date</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={moment(filters.date, "DD-MM-YYYY").format(
                      "YYYY-MM-DD"
                    )}
                    disabled
                  />
                </div>
                <div className="col-3">
                  <label htmlFor="">Production Plan</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={filters.productionPlan}
                    disabled
                  />
                </div>
                <div className="col-3">
                  <label htmlFor="">Sub Inventory</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={filters.subInventory}
                    disabled
                  />
                </div>
                <div className="mt-3 col-3">
                  <div className="row radioBtnPointer">
                    <div className="col-md-5 ">
                      <Input
                        type="radio"
                        id="all"
                        name="Radio"
                        value="1"
                        onChange={onChangeRadio}
                        checked={Level === 1}
                      ></Input>
                      <Label htmlFor="all">Level 1</Label>
                    </div>
                    <div className="col-md-5 ml-4">
                      <Input
                        type="radio"
                        id="full"
                        name="Radio"
                        value="2"
                        onChange={onChangeRadio}
                        checked={Level === 2}
                      />
                      <Label variant="custom-checkbox" htmlFor="full">
                        Level 2
                      </Label>
                    </div>
                  </div>
                </div>
              </div>
              <Collapse isOpen={data.collapseCriteria}>
                <div className="row  mt-3 mx-3">
                  <Button
                    color="success"
                    className="button-22 "
                    onClick={() =>
                      funPrintView(
                        currentData.printData,
                        currentData.headers,
                        currentData.headerKeyMap
                      )
                    }
                    id="invoiceButton"
                  >
                    Print
                  </Button>

                  {currentData.listOfData?.length > 0 ? (
                    <ExportToExcel
                      Data={currentData.listOfData}
                      listOfColKey={currentData.headerKeyMap}
                      DynamicReports={true}
                      ReportName="Production_Report_Summary"
                      criteriaString={data.criteriaString}
                    />
                  ) : null}
                </div>
              </Collapse>
              <div className="sticky-table-container">
                {Level === 1 ? (
                  <BootstrapTable
                    data={filteredData}
                    striped
                    pagination
                    hover
                    search
                    headerStyle={{
                      position: "sticky",
                      top: "0",
                    }}
                    tableHeaderClass="rpr_header"
                    tableBodyClass="rpr_body"
                    containerClass="rpr_container"
                    options={options}
                    version="4"
                  >
                    <TableHeaderColumn
                      dataField="item_code"
                      isKey={true}
                      className="rpr_header"
                      dataAlign="left"
                      width="10%"
                      row="0"
                      colSpan="2"
                      headerAlign="center"
                    >
                      Production Item
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="item_code"
                      dataAlign="left"
                      width="12%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Code
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="ITEM_DESC"
                      dataAlign="left"
                      width="12%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="qty"
                      dataAlign="center"
                      width="8%"
                      row="0"
                      rowSpan="2"
                      dataFormat={due_Formators}
                    >
                      Qty
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataAlign="left"
                      width="10%"
                      row="0"
                      colSpan="2"
                      headerAlign="center"
                    >
                      Recipe Items
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="M_ITEM_CODE"
                      dataAlign="left"
                      width="12%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Code
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="M_ITEM_DESC"
                      dataAlign="right"
                      width="10%"
                      row="1"
                      colSpan="1"
                      headerAlign="center"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataAlign="center"
                      width="30%"
                      row="0"
                      rowSpan="1"
                      colSpan="3"
                      className="rpr_header"
                    >
                      Quantities
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="REQ_QTY"
                      dataAlign="right"
                      width="10%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Required
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="STOCK_QTY"
                      dataAlign="right"
                      width="10%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Stock
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="TO_PRODUCE"
                      dataAlign="right"
                      width="10%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      To Produce
                    </TableHeaderColumn>
                  </BootstrapTable>
                ) : (
                  <BootstrapTable
                    data={filteredData}
                    striped
                    pagination
                    hover
                    search
                    headerStyle={{
                      position: "sticky",
                      top: "0",
                    }}
                    tableHeaderClass="rpr_header"
                    tableBodyClass="rpr_body"
                    containerClass="rpr_container"
                    options={options}
                    version="4"
                  >
                    <TableHeaderColumn
                      dataAlign="left"
                      width="15%"
                      row="0"
                      colSpan="2"
                      headerAlign="center"
                    >
                      Recipe Items
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="M_ITEM_CODE"
                      isKey={true}
                      dataAlign="left"
                      width="15%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Code
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="M_ITEM_DESC"
                      dataAlign="left"
                      width="20%"
                      row="1"
                      colSpan="1"
                      headerAlign="center"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataAlign="center"
                      width="50%"
                      row="0"
                      rowSpan="1"
                      colSpan="3"
                      className="rpr_header"
                    >
                      Quantities
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="REQ_QTY"
                      dataAlign="right"
                      width="15%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Required
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="STOCK_QTY"
                      dataAlign="right"
                      width="15%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      Stock
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="TO_PRODUCE"
                      dataAlign="right"
                      width="15%"
                      row="1"
                      rowSpan="1"
                      className="rpr_header"
                      dataFormat={due_Formators}
                    >
                      To Produce
                    </TableHeaderColumn>
                  </BootstrapTable>
                )}
              </div>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
